// extracted by mini-css-extract-plugin
export default {"AvatarStack":"assignees-group-header-label-module__AvatarStack--G5PaP","AggregateLabels":"assignees-group-header-label-module__AggregateLabels--zCm6b"};